export const borderWidth = {
  none: 0,
  hairline: 1,
  sm: 2,
  md: 3,
};
